// The filter control a tile presentation brings with it, beside TileSort and for the same
// reason: tiles have no header row. Choosing a column opens that column's FilterPopover under
// the select; the select returns to its prompt when the popover closes, since the chips above
// show what is in force.

import { useRef, useState } from 'react';

import FilterPopover from './FilterPopover.jsx';
import { filterColumns } from './trackerUrl.js';

export default function TileFilter({ leg, columns, query, url, onFilter }) {
  const anchorRef = useRef(null);
  const [column, setColumn] = useState(null);
  const stored = filterColumns(columns);

  return (
    <div className="tile-filter">
      <label>
        Filter by
        <select ref={anchorRef} value=""
                onChange={(e) => setColumn(stored.find((c) => c.key === e.target.value))}>
          <option value="">Choose a column…</option>
          {stored.map((candidate) => (
            <option key={candidate.key} value={candidate.key}>{candidate.label}</option>
          ))}
        </select>
      </label>
      {/* Mounted open for the chosen column and unmounted when it closes: the select is not an
          invoker, so nothing here needs the popover to exist while it is shut. */}
      {column && (
        <FilterPopover open leg={leg} column={column} search={url.filterSearch(query)}
                       initial={query.filters[column.key]} anchorRef={anchorRef}
                       onToggle={(shown) => { if (!shown) setColumn(null); }}
                       onCommit={(key, values) => { setColumn(null); onFilter(key, values); }} />
      )}
    </div>
  );
}
